import { useEffect, useState } from "react";
import { useParams } from "react-router";
import { TopBar } from "../components/TopBar";
import { TabBar } from "../components/TabBar";
import { api } from "../api/client";
import type { Exercise, ExerciseHistoryEntry } from "../api/types";
import { env } from "../env";

export const ExerciseDetail = () => {
  const { id = "" } = useParams();
  const [ex, setEx] = useState<Exercise | null>(null);
  const [history, setHistory] = useState<ExerciseHistoryEntry[]>([]);

  useEffect(() => {
    api<Exercise>(`/exercises/${id}`).then(setEx).catch(() => {});
    api<ExerciseHistoryEntry[]>(`/exercises/${id}/history`).then(setHistory).catch(() => {});
  }, [id]);

  if (!ex) return <div className="page center">Loading…</div>;

  return (
    <>
      <div className="page">
        <TopBar title={ex.name} back />
        {ex.imageKey && env.imagesUrl && (
          <img
            src={`${env.imagesUrl}/${ex.imageKey}`}
            alt={ex.name}
            style={{
              width: "100%",
              borderRadius: 12,
              background: "var(--orange-soft)",
              marginBottom: 12,
              maxHeight: 240,
              objectFit: "cover",
            }}
            onError={(e) => ((e.target as HTMLImageElement).style.display = "none")}
          />
        )}
        <div className="row" style={{ gap: 6, flexWrap: "wrap" }}>
          <span className="chip">{ex.muscleGroup}</span>
          <span className="chip muted">{ex.equipment}</span>
          <span className="chip muted">{ex.difficulty}</span>
        </div>

        {ex.description && (
          <>
            <h2 className="h2">About</h2>
            <div>{ex.description}</div>
          </>
        )}

        {ex.form && ex.form.length > 0 && (
          <>
            <h2 className="h2">Form</h2>
            <ul>
              {ex.form.map((f, i) => (
                <li key={i}>{f}</li>
              ))}
            </ul>
          </>
        )}

        {ex.mistakes && ex.mistakes.length > 0 && (
          <>
            <h2 className="h2">Common mistakes</h2>
            <ul>
              {ex.mistakes.map((m, i) => (
                <li key={i}>{m}</li>
              ))}
            </ul>
          </>
        )}

        <h2 className="h2">Your history</h2>
        {history.length === 0 ? (
          <div className="muted">No sessions yet.</div>
        ) : (
          history.map((h) => (
            <div className="card" key={h.sessionId}>
              <div className="row">
                <strong>{h.date}</strong>
                <div className="spacer" />
                <span className="muted">
                  est. 1RM {h.estOneRm ?? "–"} · vol {Math.round(h.totalVolume)}
                </span>
              </div>
              <div className="muted" style={{ marginTop: 6 }}>
                {h.sets.map((s) => `${s.weight ?? "-"}×${s.reps ?? "-"}`).join("  ·  ")}
              </div>
            </div>
          ))
        )}
      </div>
      <TabBar />
    </>
  );
};
